/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_DistrictInputs */

const cs_form_district = /** @type {(inputs: Form_DistrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Městská část`)
};

const en_form_district = /** @type {(inputs: Form_DistrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`District`)
};

/**
* | output |
* | --- |
* | "District" |
*
* @param {Form_DistrictInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_district = /** @type {((inputs?: Form_DistrictInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_DistrictInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_district(inputs)
	return cs_form_district(inputs)
});